// Customized by volto-arkus: VLT NewsItemView + author byline under the title and an
// author / "Filed under" box after the text (like the old arkusinc.com posts).
import React from 'react';
import PropTypes from 'prop-types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import config from '@plone/volto/registry';
import { Container as SemanticContainer } from 'semantic-ui-react';
import { AuthorByline, AuthorBox } from './AuthorByline';
import MoreFromArkus from './MoreFromArkus';

const splitAfterTitle = (content) => {
  const items = content?.blocks_layout?.items || [];
  const idx = items.findIndex((id) => content.blocks?.[id]?.['@type'] === 'title');
  if (idx < 0) return [null, content];
  const head = items.slice(0, idx + 1);
  const rest = items.slice(idx + 1);
  return [
    { ...content, blocks_layout: { ...content.blocks_layout, items: head } },
    { ...content, blocks_layout: { ...content.blocks_layout, items: rest } },
  ];
};

// Lead image shape (Jason, 2026-10-04): 98% of the migrated posts use a square
// Arkus icon/logo (trophy, globe, CloudFocus logo ...) as lead image, 13 use a
// landscape photo or screenshot. The theme sizes the two differently (_main.scss,
// "blog lead image"): icons small and centered, photos up to 450px high.
const leadImageClass = (content) => {
  const w = content?.image?.width;
  const h = content?.image?.height;
  if (!w || !h) return '';
  const ratio = w / h;
  return ratio >= 0.85 && ratio <= 1.18 ? 'arkus-lead-icon' : 'arkus-lead-photo';
};

const NewsItemView = ({ content }) => {
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;
  const [head, rest] = splitAfterTitle(content);
  return (
    <Container
      id="page-document"
      className={`view-wrapper newsitem-view ${leadImageClass(content)}`.trim()}
    >
      {content?.head_title && (
        <div className="dates">
          <span className="head-title"> {content.head_title}</span>
        </div>
      )}
      {head && <RenderBlocks content={head} />}
      <AuthorByline content={content} />
      <RenderBlocks content={rest} />
      <AuthorBox content={content} />
      <MoreFromArkus content={content} />
    </Container>
  );
};

NewsItemView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default NewsItemView;
